(function() {
  function initPickupDeliveryOptions() {
    const containers = document.querySelectorAll('.delivery-pickup-container');
    containers.forEach(container => {
      if (container.dataset.initialized) return;
      container.dataset.initialized = 'true';

      const pickupCard = container.querySelector('.delivery-pickup-card--pickup');
      const deliveryCard = container.querySelector('.delivery-pickup-card--delivery');
      const pickupStatusText = container.querySelector('.pickup-status-text');
      const deliveryStatusText = container.querySelector('.delivery-status-text');
      const pickupDetailsBlock = container.querySelector('.delivery-pickup-details--pickup');
      const deliveryDetailsBlock = container.querySelector('.delivery-pickup-details--delivery');
      const pickupLocationName = container.querySelector('.pickup-location-name');
      const pickupTimeText = container.querySelector('.pickup-time-text');
      const methodInput = container.querySelector('.delivery-method-input');
      const drawerTrigger = container.querySelector('.pickup-drawer-trigger');

      // Scope to the parent product-info element to support multiple products on the same page
      const productInfo = container.closest('product-info') || container.closest('.product') || document;
      const nativePickup = productInfo.querySelector('pickup-availability');

      function setActiveOption(method) {
        if (method === 'pickup') {
          if (pickupCard.classList.contains('disabled')) return;
          pickupCard.classList.add('active');
          deliveryCard.classList.remove('active');
          pickupDetailsBlock.style.display = 'block';
          deliveryDetailsBlock.style.display = 'none';
          if (methodInput) methodInput.value = 'Pick Up';
        } else {
          deliveryCard.classList.add('active');
          pickupCard.classList.remove('active');
          pickupDetailsBlock.style.display = 'none';
          deliveryDetailsBlock.style.display = 'block';
          if (methodInput) methodInput.value = 'Delivery';
        }
      }

      pickupCard.addEventListener('click', () => setActiveOption('pickup'));
      deliveryCard.addEventListener('click', () => setActiveOption('delivery'));

      if (drawerTrigger && nativePickup) {
        drawerTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          const nativeBtn = nativePickup.querySelector('.pickup-availability-button');
          if (nativeBtn) {
            nativeBtn.click();
          }
        });
      }

      function updateCardState() {
        if (!nativePickup) {
          pickupStatusText.textContent = 'Unavailable';
          pickupCard.classList.add('disabled');
          setActiveOption('delivery');
          return;
        }

        const hasAvailable = nativePickup.hasAttribute('available');
        const previewEl = nativePickup.querySelector('pickup-availability-preview');

        if (hasAvailable && previewEl) {
          pickupStatusText.textContent = 'In stock';
          pickupCard.classList.remove('disabled');

          // Use block settings values if available, otherwise extract from native element
          const defaultName = pickupLocationName ? pickupLocationName.getAttribute('data-default-name') : '';
          const defaultTime = pickupTimeText ? pickupTimeText.getAttribute('data-default-time') : '';

          if (defaultName && pickupLocationName) {
            pickupLocationName.textContent = defaultName;
          } else {
            // Fallback: extract store location name from native element
            const infoTextEl = previewEl.querySelector('.pickup-availability-info .caption-large');
            if (infoTextEl && pickupLocationName) {
              const text = infoTextEl.innerText.trim();
              const cleanedText = text.replace(/Pick up available at|Pickup available at/i, '').trim();
              pickupLocationName.textContent = cleanedText || 'Shop location';
            }
          }

          if (defaultTime && pickupTimeText) {
            pickupTimeText.textContent = defaultTime;
          } else {
            // Fallback: extract time from native element
            const timeTextEl = previewEl.querySelector('.pickup-availability-info .caption');
            if (timeTextEl && pickupTimeText) {
              pickupTimeText.textContent = timeTextEl.innerText.trim();
            }
          }
        } else {
          pickupStatusText.textContent = 'Unavailable';
          pickupCard.classList.add('disabled');
          // If pickup was selected but is now unavailable (e.g. variant change), fall back to delivery
          if (pickupCard.classList.contains('active')) {
            setActiveOption('delivery');
          }
        }

        // Update delivery card status based on variant availability
        const buyButton = productInfo.querySelector('[id^="ProductSubmitButton-"]');
        if (buyButton && buyButton.hasAttribute('disabled')) {
          if (deliveryStatusText) deliveryStatusText.textContent = 'Unavailable';
          deliveryCard.classList.add('disabled');
        } else {
          if (deliveryStatusText) deliveryStatusText.textContent = 'Available';
          deliveryCard.classList.remove('disabled');
        }
      }

      // Set up MutationObserver to watch native element updates
      if (nativePickup) {
        const observer = new MutationObserver(updateCardState);
        observer.observe(nativePickup, { attributes: true, childList: true, subtree: true });
      }

      // Run initial update
      updateCardState();
    });
  }

  // Run on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPickupDeliveryOptions);
  } else {
    initPickupDeliveryOptions();
  }

  // Run when section loads in theme customizer
  document.addEventListener('shopify:section:load', function(event) {
    initPickupDeliveryOptions();
  });
})();
